import styled from "styled-components";
 



interface ILink {
    background: string;
    extend?: boolean;
  }
  
  export const Icon = styled.a<ILink>`
    width: ${props => (props.extend ? 'auto' : '30px')};
    height: 30px;
    padding: 0px;
    margin: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 20px;
    transition: 0.2s all;
    text-decoration: none;
    background: none;
  
    border-radius: 8px;
    opacity: 0.7;
    color: ${props => (props.background ? props.background : '#444')};
  
    svg {
      font-size: 40px;
  
    }
  
    span {
      font-size: 18px;
      margin-left: 10px;
      text-decoration: none;
    }
  
    &:hover {
      font-size: 24px;
      opacity: 1;
    }
  `;


interface IIconSet {
    column: boolean;
  }
  
  export const IconSet = styled.div<IIconSet>`
    display: flex;
    justify-content: center;
    align-items: center;
  
    flex-direction: column;
  
    > div {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: ${props => (props.column ? 'column' : 'row')};
    }
  `;


export const TextMessage = styled.p`
font-size: 24px;
font-weight: bold;
margin-bottom: 20px;
display: flex;
text-align: center;
align-items: center;
justify-content: center;

max-width: 200px;
display: flex;

@media (max-width: 740px) {
  margin-bottom: 10px;
  text-align: center;
  align-items: center;
}
`;
